import { useStore } from 'vuex';
import { getUserConfigurations } from '@/vue-configurations';
import ReviewRequest from '@/models/ReviewRequest';

export function useReviewRequestComposable()
{
    const store = useStore();
    const uconfig = getUserConfigurations();

    /**
     * Check whether the current user has has unread comments for a given
     * review request.
     *
     * @param {ReviewRequest} r
     * @returns {boolean}
     */
    function hasUnreadReviewComments(r)
    {
        const lastRead = uconfig.get(`review_comments.${r.id}.last_read`);
        const ref = r.order.reference;
        const lastCommentDate = store.state.orders.lastCommentDatesByOrder.get(ref) ?? 0;
        return lastRead < lastCommentDate;
    }

    return {
        hasUnreadReviewComments,
    };
}
